import ResizeObserver from 'resize-observer-polyfill';
import { Observable } from 'rxjs';

function formatBytes(bytes, units = ['Bytes', 'KB', 'MB', 'GB']) {
    let i = Math.floor(Math.log(bytes) / Math.log(1024));
    i = Math.min(Math.max(i, 0), units.length - 1);
    return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(2))} ${units[i]}`;
}

// eslint-disable-next-line @typescript-eslint/ban-types
function executeOnChange(op, dependencies, changes) {
    for (const depenency of dependencies) {
        if (depenency in changes) {
            op();
            break;
        }
    }
}

function getStyleString(value) {
    if (typeof value === 'string') {
        return value;
    }
    return `${value}px`;
}

function debounce(func, delay) {
    let timeoutId;
    return ((...args) => {
        const f = () => {
            timeoutId = undefined;
            func(...args);
        };
        if (timeoutId !== undefined) {
            window.clearTimeout(timeoutId);
        }
        timeoutId = window.setTimeout(f, delay);
    });
}
function throttle(func, limit) {
    let delayedArgs;
    let timeoutId;
    return (...args) => {
        delayedArgs = args;
        const f = () => {
            if (delayedArgs !== undefined) {
                func(...delayedArgs);
                delayedArgs = undefined;
                timeoutId = window.setTimeout(f, limit);
            }
            else {
                timeoutId = undefined;
            }
        };
        if (timeoutId === undefined) {
            f();
        }
    };
}

function getSymmetricDifferenceOfSet(setA, setB) {
    const difference = new Set(setA);
    setB.forEach((element) => {
        if (difference.has(element)) {
            difference.delete(element);
        }
        else {
            difference.add(element);
        }
    });
    return difference;
}

function resizeObserver(elem, ngZone) {
    return new Observable((subscriber) => {
        const observer = new ResizeObserver(() => {
            ngZone.run(() => {
                subscriber.next();
            });
        });
        subscriber.next();
        observer.observe(elem);
        return () => observer.disconnect();
    });
}

/**
 * Generated bundle index. Do not edit.
 */

export { debounce, executeOnChange, formatBytes, getStyleString, getSymmetricDifferenceOfSet, resizeObserver, throttle };

//# sourceMappingURL=swire-frontline-ui-common-utils.js.map